import { cn } from '@/shared/lib/utils';
import { cva, type VariantProps } from 'class-variance-authority';
import type { ReactNode } from 'react';

/**
 * Figma "Badge & Chip" (weak).
 * - tone: success(초록) · error(빨강) · neutral(회색, 비활성)
 * - size: sm(12/SB, 목록·표) · md(14/SB, 요약 카드)
 */
const badgeVariants = cva(
  'inline-flex shrink-0 items-center justify-center whitespace-nowrap font-semibold',
  {
    variants: {
      tone: {
        success: 'bg-green-50 text-fg-success',
        error: 'bg-red-50 text-fg-error',
        neutral: 'bg-grey-100 text-fg-disabled-badge',
      },
      size: {
        sm: 'rounded-8 px-2 py-1 text-button-12',
        md: 'rounded-12 px-3 py-2 text-button-14',
      },
    },
    defaultVariants: { tone: 'success', size: 'sm' },
  },
);

interface BadgeProps extends VariantProps<typeof badgeVariants> {
  children: ReactNode;
  className?: string;
}

export function Badge({ tone, size, className, children }: BadgeProps) {
  return (
    <span className={cn(badgeVariants({ tone, size }), className)}>
      {children}
    </span>
  );
}
